import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/shared/services/auth.service';
import { Router, ActivatedRoute } from '@angular/router';
import { SettlementsService } from 'src/app/services/settlements.service';
import { ToastrService } from 'ngx-toastr';
import { faCircleNotch } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-verify-email',
  template: `
    <div class="d-flex pt-4">
      <div class="flex-fill flex-column text-center">
        <div>
          <img src="assets/images/logo-zazz.png" class="img-fluid mt-5 text-center pt-5" width="74px" alt="ZAZZ">
        </div>
      </div>
    </div>
    <div class="d-flex justify-content-center">
      <div class="flex-grow-2 text-center p-3 mt-5" *ngIf="loading" style="width: 320px;">
        <h2 class="text-center mb-0 mt-5 mb-3">Verificando cuenta</h2>
        <fa-icon [icon]="faCircleNotch" animation="spin" size="2x" class="text-zazz text-center me-2"></fa-icon>
        <p class="mt-5">Validando cuenta....</p>
      </div>
      <div class="flex-grow-2 p-3 mt-5" *ngIf="!loading" style="width: 320px;">
        <div *ngIf="!validated">
          <h2 class="text-center mb-0 mt-5 mb-3">Verificando cuenta</h2>
          <p class="text-center">Cuenta validada</p>
        </div>
        <div *ngIf="validated">
          <div class="formGroup">
            <h3 class="mb-2">Error al verificar</h3>
            <button type="button" class="btn btn-link">Renviar correo de verificación</button>
          </div>
        </div>
      </div>
    </div>

    <div class="d-flex justify-content-center">
      <div class="redirectToLogin mt-5">
        <span class=""><span class="redirect btn btn-link text-sm" routerLink="/ingresar">Iniciar sesión</span></span>
      </div>
    </div>
  `,
  styleUrls: []
})
export class VerifyEmailComponent implements OnInit {
  loading: boolean = true;
  validated: boolean = false;
  faCircleNotch = faCircleNotch;

  constructor(
    public authService: AuthService,
    private route: Router,
    private toastr: ToastrService,
    private activateRoute: ActivatedRoute,
    private settlementsService: SettlementsService
  ) {
    let ctl = this;
    this.activateRoute.params.subscribe(params => {
      setTimeout(function () {
        ctl.settlementsService.verifyEmail(params['token']).subscribe({
          next: (data: any) => {
            ctl.toastr.success("Cuenta validada", '¡Éxito!');
            ctl.loading = false;
            setTimeout(function () {
              ctl.route.navigate(['/sign-in']);
            }, 1000);
          },
          error: (err: any) => {
            console.log('err => ', err);
            ctl.loading = false;
            // ctl.toastr.error(err.error.email, 'Error');
          }
        });
      }, 1000);
    });
  }
  
  ngOnInit(): void {
  }
}
